import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../components/WebView/icons/Trashcan.svg'


const _withScopeId = n => (_pushScopeId("data-v-63940fbb"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Delete this suggestion"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "action-buttons"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "suggestion-comments" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "COMMENTS", -1))
const _hoisted_7 = {
  key: 0,
  class: "no-comments"
}
const _hoisted_8 = { ref: "commentsEnd" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertDialog = _resolveComponent("AlertDialog")!
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SuggestionDialog = _resolveComponent("SuggestionDialog")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_SuggestionsCard = _resolveComponent("SuggestionsCard")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_WebViewScreen = _resolveComponent("WebViewScreen")!

  return (_openBlock(), _createBlock(_component_WebViewScreen, {
    title: _ctx.suggestion ? _ctx.suggestion.title : '...',
    class: "detail-container"
  }, _createSlots({
    "left-button": _withCtx(() => [
      _createVNode(_component_BackButton)
    ]),
    "right-button": _withCtx(() => [
      (_ctx.canDelete)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.askDelete && _ctx.askDelete(...args)))
          }, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_AlertDialog, {
        message: `You are about to delete this suggestion`,
        show: _ctx.showDeleteConfirmation,
        "ok-title": `Delete`,
        "on-cancel": _ctx.cancelDelete,
        "on-ok": _ctx.doDelete
      }, null, 8, ["show", "on-cancel", "on-ok"]),
      (_ctx.suggestion)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.showActionButtons)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_Button, {
                    variant: "secondary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToActionsPage(_ctx.suggestion.id, 'not-now')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Not Now")
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_Button, {
                    variant: "primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToActionsPage(_ctx.suggestion.id, 'good-idea')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Let's Do It")
                    ], undefined, true),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_SuggestionsCard, null, {
              default: _withCtx(() => [
                _createVNode(_component_SuggestionDialog, {
                  title: _ctx.suggestion ? _ctx.suggestion.title : '...',
                  suggestion: _ctx.suggestion,
                  detail: true,
                  "in-dashboard": false,
                  "mention-users": _ctx.suggestionMentionUsers
                }, null, 8, ["title", "suggestion", "mention-users"]),
                (_ctx.actioningComment)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_4,
                      _createVNode(_component_Dialog, {
                        user: _ctx.actioningComment.user,
                        title: _ctx.actioningComment.user.name,
                        body: _ctx.actioningComment.body,
                        created: _ctx.actioningComment.created,
                        action: _ctx.actioningComment.action,
                        "with-vertical-line": true,
                        type: "comment"
                      }, null, 8, ["user", "title", "body", "created", "action"])
                    ], 64))
                  : _createCommentVNode("", true)
              ], undefined, true),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              (_ctx.displayComments.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, " No comments yet "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayComments, (comment) => {
                return (_openBlock(), _createBlock(_component_SuggestionsCard, {
                  key: comment.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Dialog, {
                      user: comment.user,
                      title: comment.user.name,
                      body: comment.body,
                      created: comment.created,
                      action: comment.action,
                      "with-vertical-line": true,
                      type: "comment"
                    }, null, 8, ["user", "title", "body", "created", "action"])
                  ], undefined, true),
                  _: 2
                }, 1024))
              }), 128)),
              _createElementVNode("div", _hoisted_8, null, 512)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 2
  }, [
    (!_ctx.hasBeenActioned)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createVNode(_component_TextInput, {
              placeholder: "Write a comment",
              "submit-label": "Post",
              members: _ctx.suggestionMentionUsers,
              onSubmit: _ctx.handleCreateComment
            }, null, 8, ["members", "onSubmit"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["title"]))
}